
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace, State, Getter } from 'vuex-class'
import type { User } from '@padlet/arvo'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import SurfaceActivitySvg from 'vuecomponents/surface-activity-svg.vue'

@Component({
  components: {
    AvatarImage,
    SurfaceActivitySvg,
  },
})
export default class SurfaceActivityIndicator extends Vue {
  @namespace('contributingStatus').Getter activeContributorsList!: User[]
  @namespace('contributingStatus').Getter numberOfAdditionalContributors!: number
  @namespace('contributingStatus').Getter xAdditionalContributors!: boolean
  @namespace('contributingStatus').Getter xActivityIndicator!: boolean
  @State isDesktop!: boolean
  @Getter backgroundColor!: string
  @Getter backgroundLuminance!: 'light' | 'dark'
  @namespace('draft').Getter isAnyDraftActive!: boolean

  @namespace('contributingStatus').Action('pushClear') clearContributingStatus!: () => void
  @namespace('contributingStatus').Action('pushUpdate') updateContributingStatus!: () => void

  @Watch('isAnyDraftActive')
  updateContributingStatusForAnyDraftActive(): void {
    this.updateContributingStatus()
  }
  clearContributingStatusOnPageClosed(): void {
    this.clearContributingStatus()
  }

  clearContributingStatusOnVisibilityChanged(): void {
    if (document.visibilityState === 'visible') {
      this.updateContributingStatus()
    }
    if (document.visibilityState === 'hidden') {
      this.clearContributingStatus()
    }
  }

  clearContributingStatusOnBlur(): void {
    this.clearContributingStatus()
  }
  setContributingStatusOnFocus(): void {
    this.updateContributingStatus()
  }

  mounted(): void {
    window.addEventListener('beforeunload', this.clearContributingStatusOnPageClosed)
    window.addEventListener('blur', this.clearContributingStatusOnBlur)
    window.addEventListener('focus', this.setContributingStatusOnFocus)
    window.addEventListener('visibilitychange', this.clearContributingStatusOnVisibilityChanged)
  }

  beforeDestroy(): void {
    window.removeEventListener('beforeunload', this.clearContributingStatusOnPageClosed)
    window.removeEventListener('blur', this.clearContributingStatusOnBlur)
    window.removeEventListener('focus', this.setContributingStatusOnFocus)
    window.removeEventListener('visibilitychange', this.clearContributingStatusOnVisibilityChanged)
  }
}
